import { render, staticRenderFns } from "./ApexHeatmapChart.vue?vue&type=template&id=72ed8fcd&scoped=true&"
import script from "./ApexHeatmapChart.vue?vue&type=script&lang=js&"
export * from "./ApexHeatmapChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexHeatmapChart.vue?vue&type=style&index=0&id=72ed8fcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed8fcd",
  null
  
)

export default component.exports